import { combineReducers } from 'redux';
import panel from './panel/reducer';
import authUser from './auth/reducer';
import contactDetails from './contactDetails/reducer';
import processDetails from './processDetails/reducer';
import activityDetails from './activityDetails/reducer';
import vocabularyDetails from './vocabularyDetails/reducer';
import termDetails from './termDetails/reducer';
import collectionDetails from './collectionDetails/reducer';
import nodeEdgeDetails from './nodeEdgeDetails/reducer';
import createCollectionDetails from './newCollection/reducer';
import collectionItemDetails from './collectionItemDetails/reducer';
import createCollectionItem from './newCollectionItem/reducer';
import createParticipant from './newParticipant/reducer';
import tenantDetails from './tenantDetails/reducer';
import pageLoader from './pageLoader/reducer';
import webBuilder from './webBuilder/reducer';

import signupCreate from './signupCreate/reducer';
import panelsettingsList from './panelsettingsList/reducer';
import recordListing from './recordListing/reducer';
import newRecord from './newRecord/reducer';
import editTenant from './editRecord/editTenant/reducer';
import newSettingRecord from './newSettingRecord/reducer';

import newVocabularyRecord from './newVocabularyRecord/reducer';
import newCatalogItemRecord from './newCatalogItemRecord/reducer';
import newAccountItemRecord from './newAccountItemRecord/reducer';
import newPaymentMethodItemRecord from './newPaymentMethodRecord/reducer';
import newOrderRecord from './newOrderRecord/reducer';
import newContactBlockRecord from './newContactBlockRecord/reducer';
import newPaymentItemRecord from './newPaymentItemRecord/reducer';
import invoiceDetails from './invoiceDetails/reducer';
import paymentDetails from './paymentDetails/reducer';
import orderDetails from './orderDetails/reducer';

import newProcessRecord from './newProcessRecord/reducer';

import newTermRecord from './newTermRecord/reducer';

import newTaskRecord from './newTaskRecord/reducer';
import newsFeed from './newsFeed/reducer';
import menuItemsList from './menuItemsList/reducer';
import postFeed from './postFeed/reducer';
import catalogListing from './catalog/reducer';
import termListing from './term/reducer';
import fieldDetails from './fieldDetails/reducer';
import lineItemListing from './lineItems/reducer';
import addressListing from './address/reducer';
import contactBlockListing from './contactBlock/reducer';
import paymentProfileSelect from './paymentProfileSelect/reducer';


const reducers = combineReducers({
    panel,
    authUser,
    signupCreate,
    panelsettingsList,
    nodeEdgeDetails,
    newsFeed,
    recordListing,
    newRecord,
    contactDetails,
    newSettingRecord,
    newTaskRecord,
    processDetails,
    menuItemsList,
    activityDetails,
    collectionDetails,
    createCollectionDetails,
    collectionItemDetails,
    createCollectionItem,
    createParticipant,
    tenantDetails,
    vocabularyDetails,
    termDetails,
    newVocabularyRecord,
    newCatalogItemRecord,
    newAccountItemRecord,
    newContactBlockRecord,
    newOrderRecord,
    newPaymentMethodItemRecord,
    newPaymentItemRecord,
    invoiceDetails,
    newTermRecord,
    newProcessRecord,
    editTenant,
    pageLoader,
    webBuilder,
    postFeed,
    catalogListing,
    termListing,
    fieldDetails,
    lineItemListing,
    addressListing,
    contactBlockListing,
    paymentProfileSelect,
    paymentDetails,
    orderDetails
});

export default reducers;

